import { render, staticRenderFns } from "./DocumentUploader.vue?vue&type=template&id=709e5cd5&scoped=true&"
import script from "./DocumentUploader.vue?vue&type=script&lang=js&"
export * from "./DocumentUploader.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUploader.vue?vue&type=style&index=0&id=709e5cd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e5cd5",
  null
  
)

export default component.exports